import { render, staticRenderFns } from "./FileItemCollection.vue?vue&type=template&id=fe2a7726&scoped=true&"
import script from "./FileItemCollection.vue?vue&type=script&lang=js&"
export * from "./FileItemCollection.vue?vue&type=script&lang=js&"
import style0 from "./FileItemCollection.vue?vue&type=style&index=0&id=fe2a7726&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a7726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
